import React from "react"
import PropTypes from "prop-types"
import { InstagramEmbed } from "react-social-media-embed"

const InstagramWidget = ({ blok }) => (
  <div>
    <InstagramEmbed url={blok.url} width={328} />
  </div>
)

InstagramWidget.propTypes = {
  blok: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
}

export default InstagramWidget
